import { AbstractControl, ValidationErrors } from '@angular/forms';

import { isValidIban } from './util/iban-validator.util';

export class AwValidators {
  static iban(control: AbstractControl): ValidationErrors | null {
    const { value } = control;

    if (isValidIban(value)) {
      return null;
    }

    return { iban: true };
  }
}
